import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    Auth.me()
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="font-display text-2xl">Checking session…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-5">
      <div
        data-testid="admin-login-card"
        className="brutal-border brutal-shadow-lg bg-white max-w-md w-full p-8 text-center"
      >
        <div className="inline-block brutal-border bg-[#FFB800] px-3 py-1 text-xs font-bold uppercase tracking-widest mb-5">
          KKFC Admin
        </div>
        <h1 className="font-display text-4xl uppercase leading-none mb-3">
          Welcome <span className="text-[#D92525]">back</span>
        </h1>
        <p className="text-sm text-neutral-700 mb-7">
          Manage your KKFC website — add daily offers, update the menu and
          edit restaurant info.
        </p>
        <button
          onClick={handleLogin}
          data-testid="google-login-btn"
          className="w-full inline-flex items-center justify-center gap-3 brutal-border brutal-shadow bg-black text-white font-bold px-5 py-4 text-sm uppercase tracking-widest hover:translate-y-[-2px] transition-transform"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="white">
            <path d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.79 2.71v2.26h2.9c1.7-1.56 2.69-3.87 2.69-6.61z" />
            <path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.9-2.26c-.81.54-1.84.86-3.06.86-2.35 0-4.34-1.59-5.05-3.72H.96v2.34A8.99 8.99 0 0 0 9 18z" />
            <path d="M3.95 10.7A5.4 5.4 0 0 1 3.66 9c0-.59.1-1.16.29-1.7V4.96H.96A8.99 8.99 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.99-2.34z" />
            <path d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58A8.99 8.99 0 0 0 .96 4.96L3.95 7.3C4.66 5.17 6.65 3.58 9 3.58z" />
          </svg>
          Continue with Google
        </button>
        <p className="text-[11px] text-neutral-500 mt-5 uppercase tracking-widest">
          Only the restaurant owner can access this area
        </p>
      </div>
    </div>
  );
}
